/**
 * Single source of truth for the i18n keys naming a recurring domain
 * concept (see `.claude/rules/glossary.md`). Call `t(DOMAIN_TERMS.COMPANY)`
 * instead of `t("Company")` — a typo'd or duplicated literal key is exactly
 * how "Bolag"/"Business" drifted from "Företag"/"Company" in the first
 * place. Renaming a key is then a single edit here, not a codebase grep.
 */
export const DOMAIN_TERMS = {
	DOMAIN: "Domain",
	DOMAINS: "Domains",
	COMPANY: "Company",
	COMPANIES: "Companies",
	COMPANY_NAME: "Company name",
	SOURCE_SYSTEM: "Source system",
	DATA_SOURCE: "Data source",
	DATA_SOURCES: "Data sources",
	DATA_RUN: "Data run",
	DATA_RUNS: "Data runs",
	GROUP_STRUCTURE: "Group structure",
	CURRENCY: "Currency",
	ORGANISATION_NUMBER: "Organisation number",
	ORG_NUMBER: "Org number",
} as const;
